
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('header').outerHeight();

module.exports = function () {
    $(window).scroll(function () {
        var st = $(this).scrollTop();
        
        // Ensure valid scroll value
        if (Math.abs(lastScrollTop - st) <= delta) {
            return;
        }

        // Only on mobile/tablet (check breakpoint if needed, or rely on CSS media query for effect)
        // But adding the class is harmless if CSS handles the display
        if (st > lastScrollTop && st > navbarHeight) {
            // Scroll Down
            $('header').addClass('hide-nav');
        } else {
            // Scroll Up
            if (st + $(window).height() < $(document).height()) {
                $('header').removeClass('hide-nav');
            }
        }
        
        lastScrollTop = st;
    });
};
